var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr_CA/phone_number/index.js
 ** module id = 604
 ** module chunks = 0
 **/